import { createMuiTheme } from 'material-ui/styles';
import createPalette from 'material-ui/styles/createPalette';
import { orange } from 'material-ui/colors';

const palette_colors = {
    primary: {
        ...orange,
        500: '#EF6C00',
        600: '#E65100'
    }
};

const palette = createPalette(palette_colors);
const theme = createMuiTheme({palette});

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js